<script setup>
import {getCurrentInstance} from 'vue'
import TiptapToolbarBtn from "./TiptapToolbarBtn.vue"

const props = defineProps({
    editor: {
        type: Object,
        required: true
    },
    isDidLink: {
        type: Boolean,
        required: true
    }
})

const {proxy} = getCurrentInstance()
const store = proxy.$store

// --- Methods ---

const openBrowser = () => {
    const href = props.editor.getAttributes('link').href
    const selectedId = href ? parseInt(href.match(/\d+/)[0]) : false

    const modal = store.dispatch('modals/show', {
        componentName: 'SelectListModal',
        obj: {
            listingName: 'documents.foo', // .foo namespace prevents listing from loading
            selectedIds: selectedId ? [selectedId] : [],
            onSelect: (selectedIds) => {
                const id = selectedIds.pop()
                if (id) {
                    // Highlight/select the entire existing link first, then apply the new URL
                    props.editor
                        .chain()
                        .focus()
                        .extendMarkRange('link')
                        .setLink({href: '[DID:' + id + ']'})
                        .run()
                }

                modal.then(o => store.dispatch('modals/remove', o.index))
            }
        }
    })
}
</script>

<template>
    <TiptapToolbarBtn
        :iconClass="'bi-file-earmark-pdf'"
        :command="openBrowser"
        :is-active="isDidLink"
    />
</template>